/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Sections are the indidual components found on the property report.
 * This enumerates the sections that are available for a group that
 * can be controlled.
 */
export enum Section {
    PROPERTY_GRID = 'property_grid',
    AMENITIES = 'amenities',
    BUILDING_INFORMATION = 'building_information',
    CHART_COMPARE = 'chart_compare',
    COMP_MAP = 'comp_map',
    ESTIMATED_UNIT_MIX = 'estimated_unit_mix',
    EXPOSURE_CHART = 'exposure_chart',
    FEES = 'fees',
    FINANCIAL_ANALYSIS = 'financial_analysis',
    FINISHES = 'finishes',
    FORECASTING = 'forecasting',
    FUTURE_AVAILABILITY = 'future_availability',
    LEASE_TERMS = 'lease_terms',
    MARKET_ALERTS = 'market_alerts',
    PRICE_RECOMMENDATION = 'price_recommendation',
    PROPERTY_RANKINGS_CHART = 'property_rankings_chart',
    RECOMMENDATION_HIGHLIGHTS = 'recommendation_highlights',
    RENT_TREND = 'rent_trend',
    SPECIALS_CONCESSIONS = 'specials_concessions',
    UNIT_DETAILS = 'unit_details',
    UNIT_METRICS = 'unit_metrics',
    UNIT_MIX_RECOMMENDATION = 'unit_mix_recommendation',
    UNIT_PRICES_OVER_TIME = 'unit_prices_over_time',
    UNIT_TYPE_METRICS = 'unit_type_metrics',
    UNIT_TYPE_TABLE = 'unit_type_table',
    VOLUME_OVER_TIME = 'volume_over_time',
    TAX_HISTORY = 'tax_history',
}
